module.exports = __webpack_public_path__ + "images/kurtosis2-06-desktop.png";